import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.less';
import Sider from 'antd/es/layout/Sider';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';
import useMobileBreakpoint from '../../../../hooks/useMobileBreakpoint';

const TriptychLayoutAppend = ({ children, noPadding }) => {
  const screens = useBreakpoint();

  const hasSmallPadding = !screens.xl;

  const isMobile = useMobileBreakpoint();

  const className = classNames('triptych-layout__append', {
    'triptych-layout__append--no-padding': noPadding,
    'triptych-layout__append--small-padding': (isMobile || hasSmallPadding) && !noPadding,
    'triptych-layout__append--mobile': isMobile,
  });

  return <Sider className={className}>{children}</Sider>;
};

TriptychLayoutAppend.propTypes = {
  children: PropTypes.node.isRequired,
  noPadding: PropTypes.bool,
};

TriptychLayoutAppend.defaultProps = {
  noPadding: undefined,
};

export default TriptychLayoutAppend;
